import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import DashboardLayout from '@/components/DashboardLayout';
import AuthPage from '@/pages/AuthPage';
import AdminAuthPage from '@/pages/AdminAuthPage';
import AdminPortalPage from '@/pages/AdminPortalPage';
import ClientDashboard from '@/pages/ClientDashboard';
import BrokerDashboard from '@/pages/BrokerDashboard';
import SubmitClaimPage from '@/pages/SubmitClaimPage';
import ClaimDetailPage from '@/pages/ClaimDetailPage';
import ManageClientsPage from '@/pages/ManageClientsPage';
import { USER_ROLE } from '@/utils/constants';
import '@/App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-slate-600">Loading...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/auth" />;
};

const DashboardRouter = () => {
  const { user } = useAuth();

  if (user?.role === USER_ROLE.CLIENT) {
    return <ClientDashboard />;
  } else if (user?.role === USER_ROLE.BROKER || user?.role === USER_ROLE.ADMIN) {
    return <BrokerDashboard />;
  }
  return <ClientDashboard />;
};

const ClaimsListPage = () => {
  const { user } = useAuth();
  
  if (user?.role === USER_ROLE.CLIENT) {
    return <ClientDashboard />;
  }
  return <BrokerDashboard />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/admin/auth" element={<AdminAuthPage />} />
          <Route path="/admin/portal" element={<AdminPortalPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <DashboardRouter />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/submit-claim"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <SubmitClaimPage />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/claims"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <ClaimsListPage />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/claims/:id"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <ClaimDetailPage />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-clients"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <ManageClientsPage />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <BrokerDashboard />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <ManageClientsPage />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
